import { render, staticRenderFns } from "./BankWithdrawal.vue?vue&type=template&id=aced3a4a&scoped=true&"
import script from "./BankWithdrawal.vue?vue&type=script&lang=js&"
export * from "./BankWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./BankWithdrawal.vue?vue&type=style&index=0&id=aced3a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aced3a4a",
  null
  
)

export default component.exports